
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestrounduplawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestrounduplawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestrounduplawyers/privacy-policy"])
      });
    }
  